import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=2d250921&scoped=true&"
import script from "./IndexV2.vue?vue&type=script&lang=js&"
export * from "./IndexV2.vue?vue&type=script&lang=js&"
import style0 from "./IndexV2.vue?vue&type=style&index=0&id=2d250921&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d250921",
  null
  
)

export default component.exports